(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blackbb"] && !Shopify.designMode) return;
  try {
    


(() => {
// One controller for every RCB campaign section on this page. No localStorage cart copy.
const rcbCartV7 = window.RCBCampaignCartV7 || (window.RCBCampaignCartV7 = new class {
  constructor() {
    this.sections = new Set();
    this.selected = new Map();
    this.busy = false;
    this.uncertain = false;
    this.cart = null;
    this.touched = false;
  }
  register(section) {
    this.sections.add(section);
    if (!this.bar) this.mount(section);
    this.sync();
  }
  unregister(section) {
    this.sections.delete(section);
    // Keep pending choices across an editor re-render of the same section.
    clearTimeout(this.pruneTimer);
    this.pruneTimer = setTimeout(() => {
      const ids = new Set(this.forms().map(form => this.variant(form)).filter(Boolean).map(v => v.id));
      for (const id of this.selected.keys()) if (!ids.has(id)) this.selected.delete(id);
      if (!this.sections.size) {
        this.bar?.remove(); this.spacer?.remove(); this.barObserver?.disconnect();
        this.bar = null; this.spacer = null; this.selected.clear(); this.touched = false;
      } else this.sync();
    }, 100);
  }
  mount(section) {
    const template = section.querySelector('[data-rcbd-cart-template]');
    if (!template) return;
    const fragment = template.content.cloneNode(true);
    this.bar = fragment.querySelector('.rcb-cart-v7');
    this.spacer = fragment.querySelector('[data-rcbd-cart-spacer]');
    if (!this.bar) return;
    this.labels = JSON.parse(section.dataset.commerceLabels);
    this.root = section.dataset.cartRoot || '/';
    this.cartURL = section.dataset.cartUrl;
    this.currency = section.dataset.currency;
    this.locale = section.dataset.locale || document.documentElement.lang || 'en';
    this.bar.querySelector('[data-rcbd-view-cart]').href = this.cartURL;
    document.body.append(fragment);
    this.bar.querySelector('[data-rcbd-clear]').addEventListener('click', () => {
      if (this.busy) return;
      this.selected.clear(); this.touched = Boolean(this.cart?.item_count) || this.uncertain; this.notice(''); this.sync();
    });
    this.bar.querySelector('[data-rcbd-bulk-add]').addEventListener('click', () => this.purchase(this.items(), false));
    this.bar.querySelector('[data-rcbd-checkout]').addEventListener('click', () => this.purchase(this.items(), true));
    this.barObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => this.reserve()) : null;
    this.barObserver?.observe(this.bar);
  }
  forms() {
    return [...this.sections].filter(s => s.isConnected).flatMap(s => [...s.querySelectorAll('[data-rcbd-buy]')]);
  }
  variant(form) {
    const field = form.querySelector('[data-rcbd-variant]');
    if (!field?.value) return null;
    const option = field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
    if (!option || (field.tagName === 'SELECT' && option.disabled)) return null;
    return { id: String(field.value), price: Number(option.dataset.price), option };
  }
  quantity(form) { return Number(form.querySelector('[data-rcbd-quantity]')?.value || 1); }
  validQuantity(form) {
    const q = this.quantity(form);
    return Number.isInteger(q) && q >= 1 && q <= 99;
  }
  items() { return [...this.selected.values()].map(({id, quantity}) => ({id, quantity})); }
  toggle(form, checked) {
    if (this.busy || this.uncertain) return;
    const v = this.variant(form);
    if (!v || !this.validQuantity(form)) { form.reportValidity(); this.sync(); return; }
    if (checked) this.selected.set(v.id, { id: v.id, quantity: this.quantity(form), price: v.price });
    else this.selected.delete(v.id);
    this.touched = true; this.notice(''); this.sync();
  }
  changed(form) {
    if (this.busy) return;
    const old = form.dataset.rcbdLastVariant;
    const wasSelected = old && this.selected.has(old) && form.querySelector('[data-rcbd-select]')?.checked;
    const v = this.variant(form);
    if (wasSelected && old !== v?.id) this.selected.delete(old);
    if (v && (wasSelected || this.selected.has(v.id)) && this.validQuantity(form)) {
      this.selected.set(v.id, { id: v.id, quantity: this.quantity(form), price: v.price });
    }
    this.refreshPrice(form);
    this.sync();
  }
  refreshPrice(form, previewOption = null) {
    const actual = this.variant(form);
    const v = previewOption ? {option:previewOption, price:Number(previewOption.dataset.price)} : actual;
    form.dataset.rcbdLastVariant = actual?.id || '';
    if (!v || form.querySelector('[data-rcbd-variant]').tagName !== 'SELECT') return;
    const footer = form.closest('[data-rcbd-commerce-card]');
    const data = v.option.dataset;
    const sale = footer.dataset.saleEnabled === 'true' && Number(data.compare) > v.price;
    footer.querySelector('[data-rcbd-current]').textContent = data.money;
    const compare = footer.querySelector('[data-rcbd-compare]');
    compare.textContent = data.compareMoney; compare.hidden = !sale;
    footer.querySelector('[data-rcbd-saving]').textContent = sale ? `${this.labels.save} ${data.savingMoney}` : '';
    const from = footer.querySelector('[data-rcbd-from]'); if (from) from.hidden = !previewOption;
    const card = form.closest('[data-rcbd-product]');
    card.querySelectorAll('.rcbd__name a, .rcbd__media, [data-rcbd-details]').forEach(a => { a.href = data.url; });
    const media = card.querySelector('.rcbd__media');
    if (media && data.image) {
      let image = media.querySelector('img');
      if (!image) { image = document.createElement('img'); media.replaceChildren(image); }
      // Remove the original responsive sources so the browser cannot keep the old color.
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.alt = data.imageAlt || card.querySelector('.rcbd__name')?.textContent.trim() || '';
      if (Number(data.imageWidth) > 0) image.setAttribute('width', data.imageWidth);
      if (Number(data.imageHeight) > 0) image.setAttribute('height', data.imageHeight);
      image.loading = 'eager';
      image.decoding = 'async';
      image.src = data.image;
    }
  }
  money(cents) {
    try { return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(cents / 100); }
    catch (_) { return `${(cents / 100).toFixed(2)} ${this.currency || ''}`.trim(); }
  }
  sync() {
    const owner = [...document.querySelectorAll('rcb-product-deals-v1')].find(s => this.sections.has(s));
    if (owner && this.bar) {
      this.labels = JSON.parse(owner.dataset.commerceLabels);
      const source = owner.querySelector('[data-rcbd-cart-template]').content.querySelector('.rcb-cart-v7');
      this.bar.setAttribute('style', source.getAttribute('style') || '');
      ['clear', 'bulk-add', 'checkout', 'view-cart', 'note'].forEach(key => {
        this.bar.querySelector(`[data-rcbd-${key}]`).textContent = source.querySelector(`[data-rcbd-${key}]`).textContent;
      });
    }
    this.forms().forEach(form => {
      const v = this.variant(form);
      const selected = v && this.selected.get(v.id);
      const check = form.querySelector('[data-rcbd-select]');
      if (check) {
        check.checked = Boolean(selected);
        check.disabled = this.busy || this.uncertain || !v;
        check.closest('[data-rcbd-select-row]').hidden = false;
      }
      form.closest('[data-rcbd-product]').dataset.selected = String(Boolean(selected));
      const quantity = form.querySelector('[data-rcbd-quantity]');
      if (selected) quantity.value = selected.quantity;
      form.querySelectorAll('[data-rcbd-add], [data-rcbd-variant], [data-rcbd-quantity]').forEach(el => { el.disabled = this.busy || this.uncertain || (el.hasAttribute('data-rcbd-add') && form.dataset.rcbdRegionUnavailable==='true'); });
      if(form.rcbRefreshSwatches) {
        form.querySelectorAll('[data-rcbd-option-input]').forEach(el=>{el.disabled=this.busy || this.uncertain;});
      }
      form.setAttribute('aria-busy', String(this.busy));
      form.dataset.rcbdLastVariant = v?.id || '';
    });
    if (!this.bar) return;
    this.bar.hidden = !this.touched;
    const count = [...this.selected.values()].reduce((n, x) => n + x.quantity, 0);
    const cents = [...this.selected.values()].reduce((n, x) => n + x.price * x.quantity, 0);
    const summary = count ? `${this.labels.selected} ${count} · ${this.labels.subtotal}: ${this.money(cents)}` : (this.cart ? `${this.labels.cartTotal}: ${this.money(this.cart.total_price)}` : this.labels.cartReady);
    this.bar.querySelector('[data-rcbd-total]').textContent = summary;
    this.bar.querySelector('[data-rcbd-clear]').disabled = this.busy || !count;
    this.bar.querySelector('[data-rcbd-bulk-add]').disabled = this.busy || this.uncertain || !count;
    this.bar.querySelector('[data-rcbd-checkout]').disabled = this.busy || this.uncertain || (!count && !this.cart?.item_count);
    this.bar.setAttribute('aria-busy', String(this.busy));
    this.reserve();
  }
  reserve() {
    if (!this.spacer || !this.bar) return;
    const offset = parseFloat(getComputedStyle(this.bar).getPropertyValue('--rcb-cart-offset')) || 0;
    this.spacer.style.height = this.bar.hidden ? '0px' : `${this.bar.getBoundingClientRect().height + offset + 32}px`;
  }
  notice(message, error = false, form = null) {
    const target = form?.querySelector('[data-rcbd-message]');
    if (target) { target.textContent = message; target.dataset.error = String(error); target.hidden = !message; }
    if (this.bar) {
      const p = this.bar.querySelector('[data-rcbd-bar-message]');
      p.textContent = message; p.dataset.error = String(error); p.hidden = !message;
    }
  }
  async request(url, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try { return await fetch(url, {...options, signal: controller.signal}); }
    finally { clearTimeout(timer); }
  }
  async readCart() {
    const res = await this.request(`${this.root}cart.js`, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
    if (!res.ok) throw new Error(this.labels.error);
    const cart = await res.json();
    if (!Array.isArray(cart.items) || typeof cart.total_price !== 'number') throw new Error(this.labels.error);
    this.cart = cart;
    return cart;
  }
  quantities(cart) {
    const out = new Map();
    (cart?.items || []).forEach(item => {
      const id = String(item.variant_id || item.id);
      out.set(id, (out.get(id) || 0) + item.quantity);
    });
    return out;
  }
  consume(items) {
    for (const item of items) {
      const choice = this.selected.get(String(item.id));
      if (!choice) continue;
      if (choice.quantity <= item.quantity) this.selected.delete(String(item.id));
      else choice.quantity -= item.quantity;
    }
  }
  async purchase(items, checkout, form = null) {
    if (this.busy || this.uncertain || (!items.length && !checkout)) return;
    if (form && (!this.variant(form) || !this.validQuantity(form))) { form.reportValidity(); return; }
    this.busy = true; this.touched = true; this.notice(this.labels.loading, false, form); this.sync();
    let baseline = null;
    let sent = false;
    let committed = false;
    try {
      // Snapshot first: a failed POST can still add stock-limited quantities on Shopify.
      baseline = await this.readCart();
      if (items.length) {
        sent = true;
        const response = await this.request(`${this.root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: items.map(x => ({id: x.id, quantity: x.quantity}))})
        });
        let data;
        try { data = await response.json(); } catch (_) { throw new Error(this.labels.checkCart); }
        if (!response.ok || data.status >= 400) {
          throw new Error(typeof data.description === 'string' ? data.description : this.labels.error);
        }
        committed = true;
        this.consume(items);
        // A confirmed successful add must never become a retryable add just because this read fails.
        try { await this.readCart(); } catch (_) { this.cart = null; }
      }
      if (checkout) {
        if (!items.length && !this.cart?.item_count) throw new Error(this.labels.emptyCart);
        this.checkout();
        return;
      }
      this.notice(this.labels.added, false, form);
      document.dispatchEvent(new CustomEvent('rcb:cart-updated', {detail: {cart: this.cart}}));
      // Default navigation uses the native cart, so its stock, gifts and discounts are authoritative.
      this.navigating = true;
      window.location.assign(this.cartURL);
    } catch (error) {
      if (sent && !committed) {
        try {
          const now = this.quantities(await this.readCart());
          const before = this.quantities(baseline);
          const added = items.map(item => ({id: item.id, quantity: Math.min(item.quantity, Math.max(0, (now.get(String(item.id)) || 0) - (before.get(String(item.id)) || 0)))}));
          this.consume(added);
        } catch (_) {
          // Unknown outcome: block resubmission until the shopper visits the actual cart.
          this.uncertain = true;
        }
      }
      this.notice(`${error.message || this.labels.error}${sent && !committed ? ` ${this.labels.checkCart}` : ''}`, true, form);
    } finally {
      this.busy = Boolean(this.navigating);
      this.sync();
    }
  }
  checkout() {
    this.navigating = true;
    const form = document.createElement('form');
    form.method = 'post'; form.action = this.cartURL; form.hidden = true;
    const input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
    form.append(input); document.body.append(form);
    HTMLFormElement.prototype.submit.call(form);
  }
}());

// Enhance only recognized color options; the original variant select remains the source of truth.
function rcbSetupSwatches(form, signal) {
  const ui = form.querySelector('[data-rcbd-options]');
  if (!ui) return;
  const canonical = form.querySelector('[data-rcbd-variant]');
  if (canonical?.tagName !== 'SELECT') return;
  const colorIndex = Number(ui.dataset.colorIndex);
  const options = [...canonical.options].filter(o => o.value).map(o => ({
    node:o, id:o.value, available:!o.disabled,
    values:[o.dataset.option1 || '',o.dataset.option2 || '',o.dataset.option3 || '']
  }));
  const buttons = [...ui.querySelectorAll('[data-rcbd-color-value]')];
  const inputs = [...ui.querySelectorAll('[data-rcbd-option-input]')];
  if (!options.length || (buttons.length && options.some(o => !o.values[colorIndex])) || (!buttons.length && !ui.querySelector('[data-rcbd-fixed-region]'))) return;
  const state = ['', '', ''];
  if(buttons.length===1)state[colorIndex]=buttons[0].dataset.rcbdColorValue;
  inputs.forEach(el => { state[Number(el.dataset.optionIndex)] = el.value; });
  const fixed = new Map(inputs.filter(el=>el.hasAttribute('data-rcbd-fixed-region')).map(el=>[Number(el.dataset.optionIndex),el.value]));
  const track = ui.querySelector('[data-rcbd-color-track]');
  const prev = ui.querySelector('[data-rcbd-color-prev]');
  const next = ui.querySelector('[data-rcbd-color-next]');
  const normalize = x => x.toLowerCase().trim().replace(/\s+/g,' ');
  const palette = new Map(Object.entries({
    black:'#191919',schwarz:'#191919','黑色':'#191919',blue:'#2876d3',blau:'#2876d3','蓝色':'#2876d3',
    white:'#ffffff',weiß:'#ffffff',weiss:'#ffffff','白色':'#ffffff',orange:'#ff8800',
    green:'#65a832',grün:'#65a832',gruen:'#65a832','绿色':'#65a832',red:'#d72c2c',rot:'#d72c2c','红色':'#d72c2c',
    pink:'#ec91b5',rosa:'#ec91b5','rose red':'#d94c86','玫红':'#d94c86',purple:'#8055b1',lila:'#8055b1',
    yellow:'#f3cf35',gelb:'#f3cf35',grey:'#8a8a8a',gray:'#8a8a8a',grau:'#8a8a8a',silver:'#c7c9cb',silber:'#c7c9cb',
    gold:'#c8a451',brown:'#835a3c',braun:'#835a3c',beige:'#d7c5a5',cyan:'#59b8c8',türkis:'#59b8c8',turquoise:'#59b8c8'
  }));
  (ui.dataset.swatchMap || '').split(/\r?\n/).forEach(line => {
    const i=line.indexOf(':'); if(i>0) palette.set(normalize(line.slice(0,i)),line.slice(i+1).trim());
  });
  buttons.forEach(button => {
    const dot = button.querySelector('.rcbd__swatch-dot');
    dot.replaceChildren();dot.style.backgroundColor='';
    const value = button.dataset.rcbdColorValue;
    const color = button.dataset.swatchColor || palette.get(normalize(value));
    const imageURL = button.dataset.swatchImage || (!color && options.find(o => o.values[colorIndex]===value && o.node.dataset.boundImage)?.node.dataset.image);
    if (imageURL) {
      const img=document.createElement('img');img.src=imageURL;img.alt='';img.loading='lazy';dot.append(img);
    } else if (color && (!window.CSS?.supports || CSS.supports('color',color))) dot.style.backgroundColor=color;
    else dot.textContent=value.slice(0,2).toUpperCase();
  });
  function updateArrows() {
    if(!track || !prev || !next)return;
    const max=Math.max(0,track.scrollWidth-track.clientWidth);
    const overflow=max>2;
    prev.hidden=next.hidden=!overflow;
    const pos=Math.min(max,Math.abs(track.scrollLeft));
    prev.disabled=!overflow || pos<=2;next.disabled=!overflow || pos>=max-2;
    const rtl=getComputedStyle(track).direction==='rtl';
    prev.style.transform=next.style.transform=rtl?'scaleX(-1)':'';
  }
  function matches(option,values) {return values.every((value,index)=>!value || option.values[index]===value);}
  function refreshAvailability() {
    for(let index=0;index<3;index++) {
      const prefix=state.map((v,i)=>fixed.has(i)?fixed.get(i):(i<index?v:''));
      const available=options.filter(o=>o.available && matches(o,prefix));
      const values=new Set(available.map(o=>o.values[index]));
      if(index===colorIndex) {
        if(state[index] && !values.has(state[index])) state[index]='';
        buttons.forEach(b=>{b.disabled=!values.has(b.dataset.rcbdColorValue);});
      } else {
        const field=inputs.find(el=>Number(el.dataset.optionIndex)===index);
        if(field?.tagName==='SELECT') {
          if(state[index] && !values.has(state[index])) state[index]='';
          [...field.options].forEach(o=>{if(o.value)o.disabled=!values.has(o.value);});
          field.value=state[index];
        }
      }
    }
    buttons.forEach(b=>{b.setAttribute('aria-checked',String(b.dataset.rcbdColorValue===state[colorIndex]));b.tabIndex=-1;});
    const focusButton=buttons.find(b=>b.getAttribute('aria-checked')==='true') || buttons.find(b=>!b.disabled);
    if(focusButton)focusButton.tabIndex=0;
    const colorLabel=ui.querySelector('[data-rcbd-color-name]');
    if(colorLabel)colorLabel.textContent=state[colorIndex] || '—';
    updateArrows();
  }
  function apply() {
    refreshAvailability();
    const exact=options.find(o=>o.available && o.values.every((value,index)=>!value || state[index]===value));
    canonical.value=exact?.id || '';
    form.rcbOptionChange=true;
    canonical.dispatchEvent(new Event('change',{bubbles:true}));
    form.rcbOptionChange=false;
    // Preview the selected color even while a size or market option still needs choosing.
    if(!exact && state[colorIndex]) {
      const preview=options.filter(o=>o.available && matches(o,state)).sort((a,b)=>Number(a.node.dataset.price)-Number(b.node.dataset.price))[0];
      if(preview)rcbCartV7.refreshPrice(form,preview.node);
    }
    const note=ui.querySelector('[data-rcbd-option-message]');note.hidden=true;
  }
  buttons.forEach(button=>{
    button.addEventListener('click',()=>{
      if(rcbCartV7.busy || rcbCartV7.uncertain || button.disabled)return;
      state[colorIndex]=button.dataset.rcbdColorValue;apply();
    },{signal});
    button.addEventListener('keydown',event=>{
      const available=buttons.filter(b=>!b.disabled);let i=available.indexOf(button);
      const rtl=getComputedStyle(track).direction==='rtl';
      if(event.key==='ArrowRight')i+=rtl?-1:1;
      else if(event.key==='ArrowLeft')i+=rtl?1:-1;
      else if(event.key==='Home')i=0;
      else if(event.key==='End')i=available.length-1;
      else return;
      if(!available.length)return;
      event.preventDefault();const target=available[(i+available.length)%available.length];target.click();target.focus({preventScroll:true});target.scrollIntoView({block:'nearest',inline:'nearest'});
    },{signal});
  });
  inputs.forEach(input=>input.addEventListener('change',()=>{
    if(rcbCartV7.busy || rcbCartV7.uncertain)return;
    state[Number(input.dataset.optionIndex)]=input.value;apply();
  },{signal}));
  const scroll=direction=>{
    const rtl=getComputedStyle(track).direction==='rtl'?-1:1;
    track.scrollBy({left:direction*rtl*120,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  };
  prev?.addEventListener('click',()=>scroll(-1),{signal});next?.addEventListener('click',()=>scroll(1),{signal});
  track?.addEventListener('scroll',updateArrows,{passive:true,signal});
  canonical.addEventListener('change',()=>{
    if(form.rcbOptionChange)return;
    let option=options.find(o=>o.id===canonical.value);if(!option)return;
    if([...fixed].some(([index,value])=>option.values[index]!==value)) {
      const expected=option.values.map((value,index)=>fixed.has(index)?fixed.get(index):value);
      option=options.find(o=>o.available && matches(o,expected));
      canonical.value=option?.id || '';
      if(!option)return;
    }
    option.values.forEach((value,index)=>{state[index]=value;});
    inputs.forEach(input=>{input.value=state[Number(input.dataset.optionIndex)];});
    refreshAvailability();
  },{signal});
  form.rcbRequireOptions=()=>{
    const note=ui.querySelector('[data-rcbd-option-message]');
    const label=form.closest('rcb-product-deals-v1').dataset.chooseLabel;
    note.textContent=label;note.hidden=false;
    if(buttons.length && !state[colorIndex]) (buttons.find(b=>!b.disabled))?.focus();
    else form.reportValidity();
  };
  form.dataset.rcbdRegionUnavailable=String(fixed.size>0 && !options.some(o=>o.available && [...fixed].every(([index,value])=>o.values[index]===value)));
  form.rcbRefreshSwatches=updateArrows;
  inputs.forEach(input=>{input.disabled=false;});
  ui.hidden=false;form.querySelector('[data-rcbd-native-variants]').hidden=true;
  canonical.required=false;
  const current=options.find(o=>o.id===canonical.value);
  if(current) {current.values.forEach((value,index)=>{state[index]=fixed.has(index)?fixed.get(index):value;});inputs.forEach(input=>{input.value=state[Number(input.dataset.optionIndex)];});}
  apply();
  if(form.dataset.rcbdRegionUnavailable==='true') {
    const german=form.closest('rcb-product-deals-v1').dataset.locale?.toLowerCase().startsWith('de');
    const message=ui.querySelector('[data-rcbd-option-message]');
    message.textContent=german?'Diese Version ist derzeit ausverkauft.':'This version is currently sold out.';message.hidden=false;
    form.querySelector('[data-rcbd-add]').textContent=german?'Ausverkauft':'Sold out';
  }
}

  if (customElements.get('rcb-product-deals-v1')) return;

  class RcbProductDeals extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.boot = setTimeout(() => this.init(), 0);
    }

    disconnectedCallback() { this.cleanup(); }

    cleanup() {
      clearTimeout(this.boot);
      cancelAnimationFrame(this.frame);
      if (this.commerceRegistered) { rcbCartV7.unregister(this); this.commerceRegistered = false; }
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
      this.observer = null;
    }

    init() {
      if (!this.isConnected) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.tabs = Array.from(this.querySelectorAll('[data-rcbd-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-rcbd-panel]'));
      this.grids = Array.from(this.querySelectorAll('[data-rcbd-grid]'));

      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.select(tab.dataset.rcbdTab), { signal });
        tab.addEventListener('keydown', event => this.tabKey(event, tab), { signal });
      });
      this.panels.forEach(panel => {
        panel.querySelector('[data-rcbd-prev]')?.addEventListener('click', () => this.move(panel, -1), { signal });
        panel.querySelector('[data-rcbd-next]')?.addEventListener('click', () => this.move(panel, 1), { signal });
      });
      this.grids.forEach(grid => {
        grid.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(() => this.schedule());
        this.grids.forEach(grid => this.observer.observe(grid));
      }
      document.addEventListener('shopify:block:select', event => this.editorSelect(event), { signal });

      if (this.querySelector('[data-rcbd-cart-template]')) {
        rcbCartV7.register(this);
        this.commerceRegistered = true;
        this.querySelectorAll('[data-rcbd-buy]').forEach(form => {
          rcbSetupSwatches(form, signal);
          rcbCartV7.refreshPrice(form);
          form.addEventListener('submit', event => {
            event.preventDefault();
            const v = rcbCartV7.variant(form);
            if (!v || !rcbCartV7.validQuantity(form)) { if(!v && form.rcbRequireOptions)form.rcbRequireOptions(); else form.reportValidity(); return; }
            rcbCartV7.purchase([{id: v.id, quantity: rcbCartV7.quantity(form)}], false, form);
          }, {signal});
          form.querySelector('[data-rcbd-variant]').addEventListener('change', () => rcbCartV7.changed(form), {signal});
          form.querySelector('[data-rcbd-quantity]').addEventListener('change', () => rcbCartV7.changed(form), {signal});
          form.querySelector('[data-rcbd-select]')?.addEventListener('change', event => rcbCartV7.toggle(form, event.target.checked), {signal});
        });
        rcbCartV7.sync();
      }

      this.update();
    }

    select(id, focus = false) {
      const nextPanel = this.panels.find(panel => panel.dataset.rcbdPanel === id);
      if (!nextPanel) return;
      this.panels.forEach(panel => { panel.hidden = panel !== nextPanel; });
      this.tabs.forEach(tab => {
        const active = tab.dataset.rcbdTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus({ preventScroll: true });
      });
      this.schedule();
    }

    tabKey(event, tab) {
      const rtl = getComputedStyle(this).direction === 'rtl';
      const current = this.tabs.indexOf(tab);
      let next;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (event.key === 'ArrowRight') next = current + (rtl ? -1 : 1);
      if (event.key === 'ArrowLeft') next = current + (rtl ? 1 : -1);
      if (next === undefined) return;
      event.preventDefault();
      next = (next + this.tabs.length) % this.tabs.length;
      this.select(this.tabs[next].dataset.rcbdTab, true);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      if (!this.isConnected) return;
      this.querySelectorAll('[data-rcbd-buy]').forEach(form=>form.rcbRefreshSwatches?.());
      this.panels.forEach(panel => {
        if (panel.hidden) return;
        const grid = panel.querySelector('[data-rcbd-grid]');
        const nav = panel.querySelector('[data-rcbd-nav]');
        if (!grid || !nav) return;
        const style = getComputedStyle(grid);
        const canScroll = ['auto', 'scroll'].includes(style.overflowX);
        const max = Math.max(0, grid.scrollWidth - grid.clientWidth);
        const overflow = canScroll && max > 2;
        nav.hidden = !overflow;
        const position = Math.max(0, Math.min(max, Math.abs(grid.scrollLeft)));
        const prev = panel.querySelector('[data-rcbd-prev]');
        const next = panel.querySelector('[data-rcbd-next]');
        prev.disabled = !overflow || position <= 2;
        next.disabled = !overflow || position >= max - 2;
        const rtl = style.direction === 'rtl';
        prev.style.transform = rtl ? 'scaleX(-1)' : '';
        next.style.transform = rtl ? 'scaleX(-1)' : '';
      });
    }

    move(panel, direction) {
      const grid = panel.querySelector('[data-rcbd-grid]');
      const card = grid?.querySelector('.rcbd__card');
      if (!grid || !card) return;
      const style = getComputedStyle(grid);
      const gap = parseFloat(style.columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const rtl = style.direction === 'rtl' ? -1 : 1;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      grid.scrollBy({ left: direction * rtl * step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    editorSelect(event) {
      const id = String(event.detail?.blockId || '');
      const ownGroup = this.panels.find(panel => panel.dataset.rcbdPanel === id);
      if (ownGroup) { this.select(id); return; }
      // Look up by data values rather than interpolating an editor ID in a CSS selector.
      const cards = Array.from(this.querySelectorAll('[data-rcbd-feature]'));
      const matches = cards.filter(card => card.dataset.rcbdFeature === id);
      const card = matches.find(item => !item.closest('[data-rcbd-panel]').hidden) || matches[0];
      if (!card) return;
      const panel = card.closest('[data-rcbd-panel]');
      this.select(panel.dataset.rcbdPanel);
      card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
    }
  }
  customElements.define('rcb-product-deals-v1', RcbProductDeals);
})();


(() => {
  if (customElements.get('rcb-inbox-avoidance-v1')) return;
  // Only campaign sections with direct-add enabled render a registration element.
  // Keep the Inbox host in place; adjust the offset consumed by its own shadow CSS.
  const offsetProperty = '--shopify-chat-activator-offset';
  const avoidance = new class {
    constructor() {
      this.controls = new Set(); this.saved = new Map(); this.frame = 0;
    }
    register(control) {
      this.controls.add(control);
      if (!this.abort) this.start();
      this.schedule();
    }
    unregister(control) {
      this.controls.delete(control);
      if (!this.controls.size) this.stop(); else this.schedule();
    }
    start() {
      this.abort = new AbortController(); const signal = this.abort.signal;
      const schedule = () => this.schedule();
      window.addEventListener('resize', schedule, {passive:true,signal});
      window.visualViewport?.addEventListener('resize', schedule, {passive:true,signal});
      this.domObserver = new MutationObserver(records => {
        // Ignore product text/animation changes. Watch only insertion/removal of
        // the official Inbox host and the campaign's body-mounted cart bar.
        const relevant = node => node.nodeType === 1 &&
          (node.matches('shopify-chat, .rcb-cart-v7') || node.querySelector('shopify-chat, .rcb-cart-v7'));
        if (records.some(record => [...record.addedNodes,...record.removedNodes].some(relevant))) this.schedule();
      });
      this.domObserver.observe(document.body, {childList:true,subtree:true});
      this.barObserver = new MutationObserver(schedule);
      this.resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
      this.observedBars = [];
    }
    schedule() {
      if (this.frame || !this.controls.size) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
    }
    owner() {
      // Same owner rule as the shared cart: the first direct-add section in DOM order.
      return [...document.querySelectorAll('rcb-inbox-avoidance-v1')]
        .find(control => this.controls.has(control) && control.isConnected);
    }
    watchBars(bars) {
      if (bars.length === this.observedBars.length && bars.every((bar,i) => bar === this.observedBars[i])) return;
      this.barObserver.disconnect(); this.resizeObserver?.disconnect();
      this.observedBars = bars;
      bars.forEach(bar => {
        this.barObserver.observe(bar, {attributes:true,attributeFilter:['hidden','style','class'],childList:true,subtree:true,characterData:true});
        this.resizeObserver?.observe(bar);
      });
    }
    update() {
      if (!this.controls.size || !this.abort) return;
      const bars = [...document.querySelectorAll('.rcb-cart-v7')]; this.watchBars(bars);
      const owner = this.owner();
      if (!owner || owner.dataset.enabled !== 'true') { this.restoreAll(); return; }
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const rawGap = Number(mobile ? owner.dataset.mobileGap : owner.dataset.desktopGap);
      const gap = Number.isFinite(rawGap) ? Math.max(0,Math.min(120,rawGap)) : 16;
      let clearance = 0;
      bars.forEach(bar => {
        if (bar.hidden) return;
        const css = getComputedStyle(bar), rect = bar.getBoundingClientRect();
        if (css.display === 'none' || css.visibility === 'hidden' || rect.height <= 0 || rect.bottom <= 0 || rect.top >= viewportHeight) return;
        clearance = Math.max(clearance,viewportHeight - rect.top + gap);
      });
      const hosts = [...document.querySelectorAll('shopify-chat')];
      for (const host of this.saved.keys()) {
        if (!host.isConnected || !hosts.includes(host)) this.restore(host);
      }
      if (!clearance) { this.restoreAll(); return; }
      hosts.forEach(host => this.move(host,Math.ceil(clearance)));
    }
    move(host, clearance) {
      let state = this.saved.get(host);
      const value = host.style.getPropertyValue(offsetProperty);
      const priority = host.style.getPropertyPriority(offsetProperty);
      if (state && (value !== state.applied || priority !== 'important')) {
        // Another owner changed this property: preserve their new value on restore.
        this.saved.delete(host); state = null;
      }
      if (!state) {
        state = {value,priority,base:getComputedStyle(host).getPropertyValue(offsetProperty).trim() || '20px',applied:''};
        this.saved.set(host,state);
      }
      // Never lower a launcher that Inbox already positions above the cart.
      const next = `max(${state.base}, ${clearance}px)`;
      if (value === next && priority === 'important') return;
      host.style.setProperty(offsetProperty,next,'important');
      state.applied = host.style.getPropertyValue(offsetProperty);
    }
    restore(host) {
      const state = this.saved.get(host); if (!state) return;
      if (host.style.getPropertyValue(offsetProperty) === state.applied && host.style.getPropertyPriority(offsetProperty) === 'important') {
        if (state.value) host.style.setProperty(offsetProperty,state.value,state.priority);
        else host.style.removeProperty(offsetProperty);
      }
      this.saved.delete(host);
    }
    restoreAll() { for (const host of this.saved.keys()) this.restore(host); }
    stop() {
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.abort?.abort(); this.abort = null;
      this.domObserver?.disconnect(); this.barObserver?.disconnect(); this.resizeObserver?.disconnect();
      this.observedBars = []; this.restoreAll();
    }
  };
  customElements.define('rcb-inbox-avoidance-v1',class extends HTMLElement {
    static get observedAttributes() { return ['data-enabled','data-desktop-gap','data-mobile-gap']; }
    connectedCallback() { avoidance.register(this); }
    disconnectedCallback() { avoidance.unregister(this); }
    attributeChangedCallback() { if (this.isConnected) avoidance.schedule(); }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["djs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tagName = 'rcb-countdown-bar-v1';
    if (customElements.get(tagName)) return;

    class RcbCountdownBar extends HTMLElement {
      constructor() {
        super();
        this.bootTimer = null;
        this.tickTimer = null;
        this.deadline = null;
        this.onResume = () => {
          clearTimeout(this.tickTimer);
          if (!document.hidden && this.isConnected && this.dataset.state === 'active') {
            this.tick();
          }
        };
      }

      connectedCallback() {
        this.cleanup();
        // Wait until the parser (or the theme editor) has inserted the children.
        this.bootTimer = setTimeout(() => this.initialize(), 0);
      }

      disconnectedCallback() {
        this.cleanup();
      }

      cleanup() {
        clearTimeout(this.bootTimer);
        clearTimeout(this.tickTimer);
        document.removeEventListener('visibilitychange', this.onResume);
        window.removeEventListener('pageshow', this.onResume);
      }

      // Convert a local wall-clock deadline in an explicit IANA zone to UTC.
      // Validate the round trip so impossible dates / DST gaps cannot roll over.
      // During an autumn DST fold, choose the later of the two valid instants.
      static deadlineToEpoch(dateText, timeText, timeZone) {
        const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateText || '').trim());
        const timeMatch = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(String(timeText || '').trim());
        if (!dateMatch || !timeMatch) {
          throw new Error('日期请填写 YYYY-MM-DD，时间请填写 HH:mm 或 HH:mm:ss。');
        }

        const year = Number(dateMatch[1]);
        const month = Number(dateMatch[2]);
        const day = Number(dateMatch[3]);
        const hour = Number(timeMatch[1]);
        const minute = Number(timeMatch[2]);
        const second = Number(timeMatch[3] || 0);
        if (year < 1970 || month < 1 || month > 12 || day < 1 ||
            day > new Date(Date.UTC(year, month, 0)).getUTCDate() ||
            hour > 23 || minute > 59 || second > 59) {
          throw new Error('结束日期或时间无效，请检查月份、天数及 24 小时制时间。');
        }

        let formatter;
        try {
          formatter = new Intl.DateTimeFormat('en-GB-u-ca-gregory-nu-latn', {
            timeZone,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hourCycle: 'h23'
          });
        } catch (_error) {
          throw new Error('当前浏览器不支持所选时区，请检查时区设置。');
        }

        const asWallClockUTC = (instant) => {
          const parts = {};
          formatter.formatToParts(new Date(instant)).forEach((part) => {
            if (part.type !== 'literal') parts[part.type] = Number(part.value);
          });
          return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
        };

        const wallClock = Date.UTC(year, month - 1, day, hour, minute, second);
        const offsets = new Set();
        [-36, 0, 36].forEach((hours) => {
          const probe = wallClock + hours * 3600000;
          offsets.add(asWallClockUTC(probe) - probe);
        });
        const candidates = [];
        offsets.forEach((offset) => {
          const candidate = wallClock - offset;
          if (asWallClockUTC(candidate) === wallClock) candidates.push(candidate);
        });
        if (!candidates.length) {
          throw new Error('所选当地时间处于夏令时跳过时段，请选择另一个时间。');
        }
        return Math.max(...candidates);
      }

      initialize() {
        if (!this.isConnected) return;
        this.designMode = this.dataset.designMode === 'true';
        this.intro = this.querySelector('[data-countdown-intro]');
        this.clock = this.querySelector('[data-countdown-timer]');
        this.message = this.querySelector('[data-countdown-expired]');
        this.note = this.querySelector('[data-countdown-editor-note]');
        this.values = ['days', 'hours', 'minutes', 'seconds'].map((unit) =>
          this.querySelector('[data-countdown-' + unit + ']')
        );
        if (!this.intro || !this.clock || !this.message || this.values.some((node) => !node)) {
          this.hidden = true;
          return;
        }

        this.intro.hidden = false;
        this.clock.hidden = false;
        this.message.hidden = true;
        if (this.note) this.note.hidden = true;

        try {
          this.deadline = RcbCountdownBar.deadlineToEpoch(
            this.dataset.endDate,
            this.dataset.endTime || '23:59:59',
            this.dataset.timeZone || 'Europe/Berlin'
          );
        } catch (error) {
          this.dataset.state = 'invalid';
          this.hidden = !this.designMode;
          this.values.forEach((node) => { node.textContent = '--'; });
          this.showEditorNote(error.message + ' 未设置有效时间时，店铺前台隐藏此模块。');
          return;
        }

        this.dataset.state = 'active';
        this.hidden = false;
        document.addEventListener('visibilitychange', this.onResume);
        window.addEventListener('pageshow', this.onResume);
        this.tick();
      }

      showEditorNote(text) {
        if (!this.designMode || !this.note) return;
        this.note.textContent = text;
        this.note.hidden = false;
      }

      render(totalSeconds) {
        const values = [
          Math.floor(totalSeconds / 86400),
          Math.floor(totalSeconds % 86400 / 3600),
          Math.floor(totalSeconds % 3600 / 60),
          totalSeconds % 60
        ];
        this.values.forEach((node, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (node.textContent !== value) node.textContent = value;
          node.dataset.length = String(value.length);
        });
      }

      tick() {
        clearTimeout(this.tickTimer);
        if (!this.isConnected) return;
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        this.render(remaining);
        if (remaining === 0) {
          this.dataset.state = 'expired';
          this.cleanup();
          if (this.dataset.expiryAction === 'hide') {
            this.hidden = !this.designMode;
            this.showEditorNote('活动已结束：店铺前台已隐藏。此处仅保留编辑预览，可修改结束时间。');
          } else {
            this.intro.hidden = true;
            this.clock.hidden = true;
            this.message.hidden = false;
          }
          return;
        }
        if (!document.hidden) {
          this.tickTimer = setTimeout(() => this.tick(), Math.min(1000, this.deadline - Date.now()));
        }
      }
    }

    customElements.define(tagName, RcbCountdownBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcb-flip"] && !Shopify.designMode) return;
  try {
    


(() => {
  if (customElements.get('rcb-flip-banner-v1')) return;
  class RcbFlipBanner extends HTMLElement {
    connectedCallback() { this.cleanup(); this.boot = setTimeout(() => this.init(), 0); }
    disconnectedCallback() { this.cleanup(); }
    cleanup() {
      clearTimeout(this.boot); clearTimeout(this.cycleTimer); clearTimeout(this.flipTimer);
      cancelAnimationFrame(this.frame);
      this.abort?.abort(); this.resizeObserver?.disconnect(); this.visibilityObserver?.disconnect();
      this.abort = null; this.resizeObserver = null; this.visibilityObserver = null;
    }
    init() {
      if (!this.isConnected) return;
      if (this.abort) this.cleanup();
      if (this.dataset.displayMode === 'countdown') {
        this.querySelector('[data-rfb-stage]').hidden = true;
        this.querySelector('[data-rfb-controls]').hidden = true;
        return;
      }
      this.abort = new AbortController(); const signal = this.abort.signal;
      this.stage = this.querySelector('[data-rfb-stage]');
      this.board = this.querySelector('[data-rfb-board]');
      this.fallback = this.querySelector('[data-rfb-fallback]');
      this.accessible = this.querySelector('[data-rfb-accessible]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.items = [...this.querySelectorAll('[data-rfb-item]')].map(item => {
        let text = (item.dataset.text || '').trim();
        if (this.dataset.uppercase === 'true') {
          try { text = text.toLocaleUpperCase(this.dataset.locale || 'en'); } catch (_) { text = text.toUpperCase(); }
        }
        const chars = this.characters(text).slice(0, 24);
        return { id:item.dataset.id, text:chars.join(''), chars, ink:item.dataset.ink };
      }).filter(item => item.chars.length);
      if (!this.items.length) { this.board.hidden = true; this.fallback.hidden = false; return; }
      this.slots = Math.max(...this.items.map(item => item.chars.length));
      this.speed = Math.max(400, Math.min(1200, Number(this.dataset.speed) || 700));
      this.stagger = Math.max(0, Math.min(60, Number(this.dataset.stagger) || 0));
      this.hold = Math.max(2, Math.min(12, Number(this.dataset.hold) || 4)) * 1000;
      this.index = 0; this.paused = false; this.editorHold = false;
      this.visible = typeof IntersectionObserver === 'undefined'; this.entered = false;
      this.current = Array(this.slots).fill(' '); this.target = this.current.slice();
      this.board.replaceChildren();
      this.tiles = Array.from({length:this.slots}, () => {
        const tile = document.createElement('span'); tile.className = 'rfb__tile';
        const parts = ['rfb__half--top', 'rfb__half--bottom', 'rfb__half--top rfb__old', 'rfb__half--bottom rfb__new'].map(classes => {
          const half = document.createElement('span'); half.className = `rfb__half ${classes}`;
          const glyph = document.createElement('span'); glyph.className = 'rfb__glyph'; half.append(glyph); tile.append(half); return glyph;
        });
        this.board.append(tile); return {tile, parts};
      });
      this.board.hidden = false; this.fallback.hidden = true;
      this.querySelector('[data-rfb-controls]').hidden = this.items.length < 2;
      this.querySelector('[data-rfb-pause]').hidden = this.dataset.auto !== 'true';
      this.querySelector('[data-rfb-previous]').addEventListener('click', () => this.show(this.index-1, true), {signal});
      this.querySelector('[data-rfb-next]').addEventListener('click', () => this.show(this.index+1, true), {signal});
      this.querySelector('[data-rfb-pause]').addEventListener('click', () => {
        this.paused = !this.paused; this.updatePause();
        this.dispatchEvent(new CustomEvent('rfb:motion', {detail:{paused:this.paused}}));
        if (this.paused) { clearTimeout(this.cycleTimer); this.settle(); } else this.queue();
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { clearTimeout(this.cycleTimer); this.settle(); } else this.queue();
      }, {signal});
      const motionChange = () => { this.settle(); this.queue(); };
      if (this.motion.addEventListener) this.motion.addEventListener('change', motionChange, {signal});
      window.addEventListener('resize', () => this.fit(), {passive:true,signal});
      if (typeof ResizeObserver !== 'undefined') { this.resizeObserver = new ResizeObserver(() => this.fit()); this.resizeObserver.observe(this.stage); }
      document.addEventListener('shopify:block:select', event => {
        const i = this.items.findIndex(item => item.id === String(event.detail?.blockId));
        if (i >= 0) { this.editorHold = true; this.show(i, false); }
      }, {signal});
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.items.some(item => item.id === String(event.detail?.blockId))) return;
        this.editorHold = false; this.queue();
      }, {signal});
      this.show(0, false); this.fit(); this.updatePause();
      if (typeof IntersectionObserver !== 'undefined') {
        this.visibilityObserver = new IntersectionObserver(entries => {
          const entry = entries.find(item => item.target === this); if (!entry) return;
          this.visible = entry.isIntersecting;
          if (!this.visible) { clearTimeout(this.cycleTimer); this.settle(); return; }
          this.enter();
        }, {threshold:.08});
        this.visibilityObserver.observe(this);
      } else this.enter();
    }
    characters(text) {
      if (typeof Intl.Segmenter === 'function') return [...new Intl.Segmenter(undefined,{granularity:'grapheme'}).segment(text)].map(x=>x.segment);
      return Array.from(text);
    }
    padded(chars) {
      const before = Math.floor((this.slots-chars.length)/2);
      return [...Array(before).fill(' '), ...chars, ...Array(this.slots-before-chars.length).fill(' ')];
    }
    enter() {
      if (!this.entered && this.dataset.enter === 'true' && !this.motion.matches && !this.editorHold) {
        this.entered = true;
        this.current = Array(this.slots).fill(' '); this.target = this.current.slice(); this.paint(this.current);
        this.show(this.index, true);
      } else { this.entered = true; this.queue(); }
    }
    fit() {
      if (!this.slots || !this.stage) return;
      const available = this.stage.clientWidth; if (available <= 0) return;
      const columns = available < 560 && this.slots > 14 ? Math.ceil(this.slots/2) : this.slots;
      const gap = Math.max(0, Math.min(14, Number(this.dataset.gap) || 0));
      const width = Math.max(1, Math.min(Number(this.dataset.tileWidth) || 56, (available-gap*(columns-1))/columns));
      this.board.style.gridTemplateColumns = `repeat(${columns}, ${width}px)`;
      this.board.style.setProperty('--rfb-tile-w', `${width}px`);
      this.board.style.setProperty('--rfb-tile-h', `${width*1.4}px`);
      this.board.style.setProperty('--rfb-type', `${width*.92}px`);
    }
    paint(chars) {
      this.tiles.forEach(({tile,parts}, i) => {
        tile.classList.remove('is-flipping');
        tile.dataset.blank = String(chars[i] === ' ');
        parts.forEach(glyph => { glyph.textContent = chars[i] === ' ' ? '\u00a0' : chars[i]; });
      });
    }
    settle() {
      clearTimeout(this.flipTimer); cancelAnimationFrame(this.frame);
      this.flipping = false;
      if (!this.target || !this.tiles) return;
      this.current = this.target.slice(); this.paint(this.current);
    }
    show(index, animate) {
      if (!this.items?.length) return;
      clearTimeout(this.cycleTimer); this.settle();
      this.index = (index+this.items.length)%this.items.length;
      const item = this.items[this.index]; this.target = this.padded(item.chars);
      this.accessible.textContent = item.text;
      if (item.ink) this.board.style.color = item.ink; else this.board.style.removeProperty('color');
      this.querySelector('[data-rfb-position]').textContent = `${this.index+1}/${this.items.length}`;
      if (!animate || this.motion.matches || !this.visible || document.hidden) { this.settle(); this.queue(); return; }
      const changed = [];
      this.tiles.forEach(({tile,parts}, i) => {
        const old = this.current[i] === ' ' ? '\u00a0' : this.current[i];
        const next = this.target[i] === ' ' ? '\u00a0' : this.target[i];
        if (old === next) return;
        tile.dataset.blank = 'false'; tile.style.setProperty('--rfb-delay', `${i*this.stagger}ms`);
        parts[0].textContent = next; parts[1].textContent = old; parts[2].textContent = old; parts[3].textContent = next;
        changed.push(tile);
      });
      if (!changed.length) { this.settle(); this.queue(); return; }
      this.flipping = true;
      this.frame = requestAnimationFrame(() => {
        changed.forEach(tile => tile.classList.add('is-flipping'));
        this.flipTimer = setTimeout(() => { this.settle(); this.queue(); },this.speed+(this.slots-1)*this.stagger+40);
      });
    }
    queue() {
      clearTimeout(this.cycleTimer);
      if (!this.isConnected || !this.visible || document.hidden || this.paused || this.editorHold || this.flipping || this.dataset.auto !== 'true' || this.items.length < 2) return;
      this.cycleTimer = setTimeout(() => this.show(this.index+1,true), this.hold);
    }
    updatePause() {
      const button = this.querySelector('[data-rfb-pause]');
      button.setAttribute('aria-pressed', String(this.paused));
      button.setAttribute('aria-label', this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
      this.querySelector('[data-rfb-pause-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
    }
  }
  customElements.define('rcb-flip-banner-v1',RcbFlipBanner);
})();


(() => {
  if(customElements.get('rcb-flip-countdown-v1'))return;
  class RcbFlipCountdown extends HTMLElement {
    connectedCallback(){this.cleanup();this.boot=setTimeout(()=>this.init(),0);}
    disconnectedCallback(){this.cleanup();}
    cleanup(){
      clearTimeout(this.boot);clearTimeout(this.clockTimer);clearTimeout(this.animationTimer);cancelAnimationFrame(this.frame);
      this.abort?.abort();this.resize?.disconnect();this.intersection?.disconnect();
      this.abort=null;this.resize=null;this.intersection=null;
    }
    // Local campaign dates are resolved in the selected IANA zone, independent of the shopper's zone.
    parseDate(value,zone){
      const text=(value||'').trim();
      const match=text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:?\d{2})?$/i);
      if(!match)return NaN;
      const [year,month,day,hour,minute,second]=match.slice(1,7).map(x=>Number(x||0));
      if(year<1970 || year>9999 || month<1 || month>12 || day<1 || day>31 || hour>23 || minute>59 || second>59)return NaN;
      const wall=Date.UTC(year,month-1,day,hour,minute,second);
      const check=new Date(wall);
      if(check.getUTCFullYear()!==year || check.getUTCMonth()!==month-1 || check.getUTCDate()!==day)return NaN;
      if(match[7])return Date.parse(text.replace(' ','T'));
      try{
        const format=new Intl.DateTimeFormat('en-GB',{timeZone:zone,hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'});
        let guess=wall;
        for(let i=0;i<4;i++){
          const p={};format.formatToParts(new Date(guess)).forEach(x=>{if(x.type!=='literal')p[x.type]=Number(x.value);});
          const observed=Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);
          const delta=wall-observed;
          if(delta===0)return guess;
          guess+=delta;
        }
        // A local time skipped by a daylight-saving transition is rejected.
        return NaN;
      }catch(_){return NaN;}
    }
    init(){
      if(!this.isConnected)return;
      if(this.abort)this.cleanup();
      this.owner=this.closest('rcb-flip-banner-v1');
      if(this.owner?.dataset.displayMode==='phrases'){this.hidden=true;return;}
      this.abort=new AbortController();const signal=this.abort.signal;
      this.unitsNode=this.querySelector('[data-rfc-units]');
      this.statusNode=this.querySelector('[data-rfc-status]');
      this.endedNode=this.querySelector('[data-rfc-ended]');
      this.accessible=this.querySelector('[data-rfc-accessible]');
      this.groups=null;this.endedNode.hidden=true;this.querySelector('[data-rfc-error]').hidden=true;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.motionPaused=Boolean(this.owner?.paused);
      this.start=this.parseDate(this.dataset.start,this.dataset.zone||'Europe/Berlin');
      this.end=this.parseDate(this.dataset.end,this.dataset.zone||'Europe/Berlin');
      if(!Number.isFinite(this.start)||!Number.isFinite(this.end)||this.end<=this.start){
        this.hidden=this.dataset.editor!=='true';this.unitsNode.hidden=true;this.statusNode.hidden=true;
        const error=this.querySelector('[data-rfc-error]');error.hidden=false;
        error.textContent='请检查倒计时：日期格式为 YYYY-MM-DD HH:mm:ss，结束时间须晚于开始时间；所选时区内该时间必须有效。';
        return;
      }
      this.hidden=false;this.speed=Math.max(200,Math.min(800,Number(this.dataset.speed)||400));
      this.visible=typeof IntersectionObserver==='undefined';this.groups=[];
      this.unitsNode.replaceChildren();
      ['days','hours','minutes','seconds'].forEach(key=>{
        const wrapper=document.createElement('div');wrapper.className='rfct__unit';
        const digits=document.createElement('div');digits.className='rfct__digits';
        const label=document.createElement('p');label.className='rfct__unit-label';label.textContent=this.dataset[key];
        wrapper.append(digits,label);this.unitsNode.append(wrapper);this.groups.push({key,digits,tiles:[],value:''});
      });
      document.addEventListener('visibilitychange',()=>{if(document.hidden){clearTimeout(this.clockTimer);this.settle();}else this.tick();},{signal});
      this.owner?.addEventListener('rfb:motion',event=>{this.motionPaused=Boolean(event.detail?.paused);if(this.motionPaused)this.settle();},{signal});
      if(this.motion.addEventListener)this.motion.addEventListener('change',()=>this.settle(),{signal});
      window.addEventListener('resize',()=>this.fit(),{signal,passive:true});
      if(typeof ResizeObserver!=='undefined'){this.resize=new ResizeObserver(()=>this.fit());this.resize.observe(this);}
      this.tick();
      if(typeof IntersectionObserver!=='undefined'){
        this.intersection=new IntersectionObserver(entries=>{
          const entry=entries.find(item=>item.target===this);if(!entry)return;
          this.visible=entry.isIntersecting;
          if(this.visible)this.tick();else{clearTimeout(this.clockTimer);this.settle();}
        },{threshold:.05});this.intersection.observe(this);
      }
    }
    phase(now){
      if(now<this.start)return {state:'before',target:this.start,label:this.dataset.before};
      if(now<this.end)return {state:'during',target:this.end,label:this.dataset.during};
      return {state:'ended',target:this.end,label:this.dataset.ended};
    }
    tick(){
      clearTimeout(this.clockTimer);if(!this.isConnected || !this.groups)return;
      const now=Date.now(),phase=this.phase(now);this.dataset.state=phase.state;
      const ended=phase.state==='ended';this.unitsNode.hidden=ended;this.statusNode.hidden=ended;this.endedNode.hidden=!ended;
      if(ended){this.settle();this.accessible.textContent=phase.label;return;}
      this.statusNode.textContent=phase.label;
      const remaining=Math.max(0,Math.ceil((phase.target-now)/1000));
      const values=[Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60].map(n=>String(n).padStart(2,'0'));
      this.renderDigits(values);
      this.accessible.textContent=`${phase.label}: ${values.map((value,i)=>`${Number(value)} ${this.dataset[this.groups[i].key]}`).join(', ')}`;
      if(this.visible&&!document.hidden)this.clockTimer=setTimeout(()=>this.tick(),Math.max(30,1000-Date.now()%1000+15));
    }
    tile(){
      const tile=document.createElement('span');tile.className='rfb__tile';
      const parts=['rfb__half--top','rfb__half--bottom','rfb__half--top rfb__old','rfb__half--bottom rfb__new'].map(classes=>{
        const half=document.createElement('span');half.className=`rfb__half ${classes}`;
        const glyph=document.createElement('span');glyph.className='rfb__glyph';half.append(glyph);tile.append(half);return glyph;
      });return {tile,parts};
    }
    settle(){
      clearTimeout(this.animationTimer);cancelAnimationFrame(this.frame);
      this.groups?.forEach(group=>group.tiles.forEach(({tile,parts},i)=>{tile.classList.remove('is-flipping');parts.forEach(glyph=>{glyph.textContent=group.value[i]||'0';});}));
    }
    renderDigits(values){
      this.settle();const changed=[];
      this.groups.forEach((group,index)=>{
        const next=values[index],old=group.value;
        if(group.tiles.length!==next.length){
          group.digits.replaceChildren();group.tiles=[...next].map(()=>{const item=this.tile();group.digits.append(item.tile);return item;});
          group.value=next;group.tiles.forEach(({parts},i)=>parts.forEach(g=>{g.textContent=next[i];}));return;
        }
        group.value=next;
        group.tiles.forEach(({tile,parts},i)=>{
          if(next[i]===old[i])return;
          parts[0].textContent=next[i];parts[1].textContent=old[i];parts[2].textContent=old[i];parts[3].textContent=next[i];
          tile.style.setProperty('--rfb-delay','0ms');changed.push(tile);
        });
      });
      this.fit();
      if(!changed.length)return;
      if(!this.visible||document.hidden||this.motion.matches||this.motionPaused){this.settle();return;}
      this.frame=requestAnimationFrame(()=>{
        changed.forEach(tile=>tile.classList.add('is-flipping'));
        this.animationTimer=setTimeout(()=>this.settle(),this.speed+30);
      });
    }
    fit(){
      if(!this.groups?.length)return;
      const available=this.unitsNode.clientWidth;if(available<=0)return;
      const gap=parseFloat(getComputedStyle(this.unitsNode).columnGap)||8;
      const digitGap=parseFloat(getComputedStyle(this.groups[0].digits).columnGap)||2;
      const longest=Math.max(...this.groups.map(group=>group.tiles.length),2);
      const unit=(available-gap*3)/4;
      const width=Math.max(1,Math.min(Number(this.dataset.digitWidth)||36,(unit-digitGap*(longest-1))/longest));
      this.style.setProperty('--rfb-tile-w',`${width}px`);this.style.setProperty('--rfb-tile-h',`${width*1.4}px`);this.style.setProperty('--rfb-type',`${width*.92}px`);
    }
  }
  customElements.define('rcb-flip-countdown-v1',RcbFlipCountdown);
})();


(() => {
  if (customElements.get('rcb-coupon-codes-v1')) return;
  class RcbCouponCodes extends HTMLElement {
    connectedCallback() { this.cleanup(); this.boot = setTimeout(() => this.init(), 0); }
    disconnectedCallback() { this.cleanup(); }
    cleanup() {
      clearTimeout(this.boot);
      this.abort?.abort(); this.abort = null;
      this.resetTimers?.forEach(timer => clearTimeout(timer));
      this.resetTimers = new Map();
      this.querySelectorAll('[data-rfcp-copy]').forEach(button => { button.disabled = false; });
    }
    init() {
      if (!this.isConnected) return;
      this.abort = new AbortController(); const signal = this.abort.signal;
      this.status = this.querySelector('[data-rfcp-status]');
      this.querySelectorAll('[data-rfcp-copy]').forEach(button => {
        button.hidden = false; this.paint(button, false);
        button.addEventListener('click', () => this.copy(button, signal), {signal});
      });
    }
    paint(button, success) {
      button.classList.toggle('is-copied', success);
      button.querySelector('[data-rfcp-button-label]').textContent = success ? this.dataset.copiedLabel : this.dataset.copyLabel;
      button.querySelector('[data-rfcp-copy-icon]').toggleAttribute('hidden', success);
      button.querySelector('[data-rfcp-check-icon]').toggleAttribute('hidden', !success);
    }
    async copy(button, signal) {
      if (button.disabled || signal.aborted) return;
      const card = button.closest('[data-rfcp-card]');
      const input = card?.querySelector('[data-rfcp-input]');
      if (!input || !input.value.trim()) return;
      clearTimeout(this.resetTimers.get(button)); this.resetTimers.delete(button);
      this.paint(button, false); this.status.textContent = ''; button.disabled = true;
      let copied = false;
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          await navigator.clipboard.writeText(input.value); copied = true;
        }
      } catch (_) { /* Clipboard permissions can be denied in the theme editor. */ }
      if (signal.aborted || !this.isConnected) return;
      if (!copied) copied = this.legacyCopy(input);
      if (signal.aborted || !this.isConnected) return;
      button.disabled = false;
      if (copied) {
        card.querySelector('[data-rfcp-manual]').hidden = true;
        button.focus({preventScroll:true}); this.paint(button, true);
        this.status.textContent = `${input.value}: ${this.dataset.successMessage}`;
        this.resetTimers.set(button, setTimeout(() => {
          this.resetTimers.delete(button); if (this.isConnected && !signal.aborted) this.paint(button, false);
        }, 2500));
      } else {
        card.querySelector('[data-rfcp-manual]').hidden = false;
        input.focus({preventScroll:true}); input.select(); input.setSelectionRange(0, input.value.length);
        this.status.textContent = this.dataset.manualMessage;
      }
    }
    legacyCopy(input) {
      const manual = input.closest('[data-rfcp-manual]');
      const wasHidden = manual.hidden; manual.hidden = false;
      let copied = false;
      try {
        input.focus({preventScroll:true}); input.select(); input.setSelectionRange(0, input.value.length);
        copied = typeof document.execCommand === 'function' && document.execCommand('copy') === true;
      } catch (_) { copied = false; }
      if (copied && wasHidden) manual.hidden = true;
      return copied;
    }
  }
  customElements.define('rcb-coupon-codes-v1', RcbCouponCodes);
})();


  } catch(e) { console.error(e); }
})();
})();
